import NextImage from 'next/image'
import { HeaderImage } from 'types/header'
import styles from './style.module.scss'
import Badge, { BadgeProps } from '@components/ui/Badge'
import { getLink } from '@helpers/env'

type PromoImageContentProps = Pick<
  PromoImageProps,
  'badge' | 'title' | 'image' | 'visible' | 'width' | 'height'
>

function PromoImageContent({
  visible,
  image,
  width,
  height,
  badge,
  title
}: PromoImageContentProps) {
  return (
    <>
      <div className={styles.promoImageWrapper__promoImage}>
        {visible && image && (
          <NextImage
            src={image.url}
            alt={image.title}
            width={width}
            height={height}
          />
        )}

        {badge && (
          <Badge
            classes={styles.promoImageWrapper__badge}
            title={badge.title}
            themeColour={badge.themeColour}
            badgeType={'filled'}
            small={true}
          />
        )}
      </div>
      <h3 className={styles.promoImageWrapper__title}>{title}</h3>
    </>
  )
}

export type PromoImageProps = {
  title: string | null
  handle: string | null
  image: HeaderImage | null
  badge?: BadgeProps | null
  width: number
  height: number
  visible: boolean | null
  onClick: (title: string) => void
}

export default function PromoImage({
  title,
  handle,
  image,
  width,
  height,
  badge,
  visible = true,
  onClick
}: PromoImageProps) {
  if (!handle) {
    return (
      <div
        className={styles.promoImageWrapper}
        style={
          {
            '--width': `${width}px`,
            '--height': `${height}px`
          } as React.CSSProperties
        }
      >
        <PromoImageContent
          visible={visible}
          image={image}
          width={width}
          height={height}
          title={title}
          badge={badge}
        />
      </div>
    )
  }
  return (
    <a
      href={getLink(handle)}
      {...(title && { onClick: () => onClick(title) })}
      className={styles.promoImageWrapper}
      style={
        {
          '--width': `${width}px`,
          '--height': `${height}px`
        } as React.CSSProperties
      }
    >
      <PromoImageContent
        visible={visible}
        image={image}
        width={width}
        height={height}
        title={title}
        badge={badge}
      />
    </a>
  )
}
